export default "__VITE_ASSET__BqHs7pKH__"